import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table'
import useSWR, { mutate } from 'swr'
import { useToast } from '@/hooks/use-toast'
import { useLocation } from 'wouter'
import { Transaction, TRANSACTION_TYPES } from '@/constants'
import Header from '@/components/Header'
import { apiFetch } from '@/utils'

export default function AdminTransactionsPage() {
  const { toast } = useToast()
  const [, navigate] = useLocation()
  const { data: transactions, error: transactionError } = useSWR<Transaction[]>(
    '/v1/transactions',
    async () => {
      const response = await apiFetch('/v1/transactions', {
        withCredentials: true
      })

      return response.json()
    }
  )

  return (
    <>
      <Header />
      <div className="container mx-auto p-4 max-w-4xl">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Transcations</h1>
        </div>

        <div className="flex flex-col gap-6">
          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">Recent Transactions</h2>
            {transactionError ? (
              <div className="text-destructive">
                Failed to load transactions
              </div>
            ) : !transactions ? (
              <div className="text-muted-foreground">
                Loading transactions...
              </div>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Date</TableHead>
                    <TableHead>Type</TableHead>
                    <TableHead>Amount (SECH)</TableHead>
                    <TableHead>Customer</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {transactions.map((tx) => (
                    <TableRow key={tx.id}>
                      <TableCell>
                        {new Date(tx.timestamp).toLocaleDateString()}
                      </TableCell>
                      <TableCell>{TRANSACTION_TYPES[tx.type]}</TableCell>
                      <TableCell>
                        {parseFloat(tx.amount.toString()).toFixed(6)}
                      </TableCell>
                      <TableCell>
                        {tx.toAddress.slice(0, 6)}...{tx.toAddress.slice(-4)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Card>
        </div>
      </div>
    </>
  )
}
